module.exports = __webpack_public_path__ + "d604b26e5386c26e20391de049300886.png";